module.exports = __webpack_public_path__ + "img/child-one.5a02c4cc.png";